export const CLIENT_LIBRARIES = [
  {
    language: 'Javascript',
    key: 'javascript',
    is_officially_supported: true,
    libraries: [
      {
        name: 'supabase-js',
        url: 'https://github.com/supabase/supabase-js',
      },
      {
        name: 'postgrest-js',
        url: 'https://github.com/supabase/postgrest-js',
      },
      {
        name: 'gotrue-js',
        url: 'https://github.com/supabase/gotrue-js',
      },
      {
        name: 'realtime-js',
        url: 'https://github.com/supabase/realtime-js',
      },
      {
        name: 'storage-js',
        url: 'https://github.com/supabase/storage-js',
      },
      {
        name: 'functions-js',
        url: 'https://github.com/supabase/functions-js',
      },
    ],
  },
  {
    language: 'C#',
    key: 'csharp',
    is_officially_supported: false,
    libraries: [
      {
        name: 'supabase-csharp',
        url: 'https://github.com/supabase-community/supabase-csharp',
      },
      {
        name: 'postgrest-csharp',
        url: 'https://github.com/supabase-community/postgrest-csharp',
      },
      {
        name: 'gotrue-csharp',
        url: 'https://github.com/supabase-community/gotrue-csharp',
      },
      {
        name: 'realtime-csharp',
        url: 'https://github.com/supabase-community/realtime-csharp',
      },
      {
        name: 'storage-csharp',
        url: 'https://github.com/supabase-community/storage-csharp',
      },
      {
        name: 'functions-csharp',
        url: 'https://github.com/supabase-community/functions-csharp',
      },
    ],
  },
  {
    language: 'Dart (Flutter)',
    key: 'dart',
    is_officially_supported: false,
    libraries: [
      {
        name: 'supabase-flutter',
        url: 'https://github.com/supabase-community/supabase-flutter',
      },
      {
        name: 'supabase-dart',
        url: 'https://github.com/supabase-community/supabase-dart',
      },
      {
        name: 'postgrest-dart',
        url: 'https://github.com/supabase-community/postgrest-dart',
      },
      {
        name: 'gotrue-dart',
        url: 'https://github.com/supabase-community/gotrue-dart',
      },
      {
        name: 'realtime-dart',
        url: 'https://github.com/supabase-community/realtime-dart',
      },
      {
        name: 'storage-dart',
        url: 'https://github.com/supabase-community/storage-dart',
      },
      {
        name: 'functions-dart',
        url: 'https://github.com/supabase-community/functions-dart',
      },
    ],
  },
  {
    language: 'Go',
    key: 'go',
    is_officially_supported: false,
    libraries: [
      {
        name: 'postgrest-go',
        url: 'https://github.com/supabase-community/postgrest-go',
      },
      {
        name: 'storage-go',
        url: 'https://github.com/supabase-community/storage-go',
      },
      {
        name: 'functions-go',
        url: 'https://github.com/supabase-community/functions-go',
      },
    ],
  },
  {
    language: 'Java',
    key: 'java',
    is_officially_supported: false,
    libraries: [
      {
        name: 'gotrue-java',
        url: 'https://github.com/supabase-community/gotrue-java',
      },
    ],
  },
  {
    language: 'Kotlin',
    key: 'kotlin',
    is_officially_supported: false,
    libraries: [
      {
        name: 'postgrest-kt',
        url: 'https://github.com/supabase-community/supabase-kt/tree/master/Postgrest',
      },
      {
        name: 'auth-kt',
        url: 'https://github.com/supabase-community/supabase-kt/tree/master/Auth',
      },
      {
        name: 'storage-kt',
        url: 'https://github.com/supabase-community/supabase-kt/tree/master/Storage',
      },
      {
        name: 'realtime-kt',
        url: 'https://github.com/supabase-community/supabase-kt/tree/master/Realtime',
      },
      {
        name: 'functions-kt',
        url: 'https://github.com/supabase-community/supabase-kt/tree/master/Functions',
      },
    ],
  },
  {
    language: 'Python',
    key: 'python',
    is_officially_supported: true,
    libraries: [
      {
        name: 'supabase-py',
        url: 'https://github.com/supabase/supabase-py',
      },
      {
        name: 'postgrest-py',
        url: 'https://github.com/supabase/postgrest-py',
      },
      {
        name: 'gotrue-py',
        url: 'https://github.com/supabase/gotrue-py',
      },
      {
        name: 'realtime-py',
        url: 'https://github.com/supabase/realtime-py',
      },
      {
        name: 'storage-py',
        url: 'https://github.com/supabase/storage-py',
      },
      {
        name: 'functions-py',
        url: 'https://github.com/supabase/functions-py',
      },
    ],
  },
  {
    language: 'Ruby',
    key: 'ruby',
    is_officially_supported: false,
    libraries: [
      {
        name: 'supabase-ruby',
        url: 'https://github.com/supabase-community/supabase-rb',
      },
      {
        name: 'postgrest-ruby',
        url: 'https://github.com/supabase-community/postgrest-rb',
      },
    ],
  },
  {
    language: 'Rust',
    key: 'rust',
    is_officially_supported: false,
    libraries: [
      {
        name: 'postgrest-rs',
        url: 'https://github.com/supabase-community/postgrest-rs',
      },
    ],
  },
  {
    language: 'Swift',
    key: 'swift',
    is_officially_supported: false,
    libraries: [
      {
        name: 'supabase-swift',
        url: 'https://github.com/supabase/supabase-swift',
      },
      {
        name: 'postgrest-swift',
        url: 'https://github.com/supabase-community/postgrest-swift',
      },
      {
        name: 'gotrue-swift',
        url: 'https://github.com/supabase-community/gotrue-swift',
      },
      {
        name: 'realtime-swift',
        url: 'https://github.com/supabase-community/realtime-swift',
      },
      {
        name: 'storage-swift',
        url: 'https://github.com/supabase-community/storage-swift',
      },
    ],
  },
  {
    language: 'Godot Engine (GDScript)',
    key: 'gdscript',
    is_officially_supported: false,
    libraries: [
      {
        name: 'supabase-gdscript',
        url: 'https://github.com/supabase-community/godot-engine.supabase',
      },
      {
        name: 'postgrest-gdscript',
        url: 'https://github.com/supabase-community/postgrest-gdscript',
      },
      {
        name: 'gotrue-gdscript',
        url: 'https://github.com/supabase-community/gotrue-gdscript',
      },
      {
        name: 'realtime-gdscript',
        url: 'https://github.com/supabase-community/realtime-gdscript',
      },
      {
        name: 'storage-gdscript',
        url: 'https://github.com/supabase-community/storage-gdscript',
      },
      {
        name: 'functions-gdscript',
        url: 'https://github.com/supabase-community/functions-gdscript',
      },
    ],
  },
]
